<template>
<div>
    <Blackjack/>
</div>
</template>

<script>
import Blackjack from './Games/Blackjack.vue'
export default {
    components:{
        Blackjack
    },
    created() {
    window.location.href = "https://cosmic-labs.io/oldunstake"; // Replace with your desired URL
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Casino.vue